import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_330: DocMigration = {
  maxSchemaVersion: "0.0.330",
  description: "Combine isExteriorArchitecturalProp and isInteriorArchitecturalProp flags",
  apply(json: any) {
    const settingsTable: any[] = Object.values(json.settings);
    for (const settings of settingsTable) {
      if (settings.type === "INTERIOR_PROP_SETTINGS" || settings.type === "EXTERIOR_PROP_SETTINGS") {
        if (!settings.propTypes) {
          continue;
        }
        const propCatalog: any[] = Object.values(settings.propTypes);
        const isExteriorCatalog = settings.type === "EXTERIOR_PROP_SETTINGS";
        for (const prop of propCatalog) {
          const propAssumedArchitectural =
            prop.forceOnExteriorViews || (isExteriorCatalog && !prop.excludeFromExteriorViews);
          if (
            prop.isInteriorArchitecturalProp !== undefined ||
            prop.isExteriorArchitecturalProp !== undefined ||
            propAssumedArchitectural
          ) {
            prop.isArchitecturalProp =
              prop.isInteriorArchitecturalProp || prop.isExteriorArchitecturalProp || propAssumedArchitectural;
          }
          if (prop.excludeFromExteriorViews !== undefined) {
            // This setting was previously ignored for interior props.
            // For exterior props we can combine it with the "is architectural" flag.
            delete prop.excludeFromExteriorViews;
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_330;
